<template>
  <div class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
    export default {
        name: "AppMain",
        computed: {
            key() {
                return this.$route.path;
            },
        },
        data() {
            return {};
        },
        methods: {},
    };
</script>
<style lang="scss" scoped>
    @import "../../style/variables.scss";

    .app-main {
        min-width: 1000px;
        flex: 1;
        // margin: 5px 20px 20px 20px;
        margin-left: 5px;
        overflow-y: scroll;
    }
</style>